import React from 'react';
import { Row, Col, Select } from 'antd';
import BaseAllTimePage from '../../common/baseAllTimePage';
import Header from '../../common/allTimeHeader';
import MembersWidget from './members.js';
import PointsEarnedWidget from './pointsEarned.js';
import PrayingWidget from './praying.js';
import FastingWidget from './fasting.js';
import OvercomingWidget from './overcoming.js';
import GuestCardActivitiesWidget from './guestCardActivities.js';
import GoalsAndAveragesWidget from './goalsAndAverages.js';
import GroupPerformanceWidget from './groupPerformance.js';
import WidgetContainer from '../../common/widgetContainer';

export default class AllTimePage extends BaseAllTimePage {
  componentWillMount() {
    if(!this.groupIdFromUrl) {
      this.setQueryParam('groupId', this.props.selectedChurchGroups[0].id);
    }
  }

  get widgetParams() {
    return {
      churchId: this.props.selectedChurch.id,
      churchGroupId: parseInt(this.groupIdFromUrl, 10),
      timezone: this.props.selectedChurch.timezone
    }
  }

  get revivalParams() {
    return this.props.revivalWeeks.church.revival;
  }

  get groupIdFromUrl() {
    const query = new URLSearchParams(this.props.history.location.search);
    return query.get('groupId');
  }

  getGroupSelectFilterOptions(input, option) {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  onGroupChange = (value) => {
    this.setQueryParam('groupId', value);
  };

  get header() {
    return (
      <Row className="statistics-page-header-row">
        <Col size={24} className="statistics-page-header-with-filter">
          <div className="statistics-page-header">
            <Header revivalWeeks={this.props.revivalWeeks} />
          </div>
          <Select showSearch style={{ width: 250 }} placeholder="Select a group" optionFilterProp="children"
                  onChange={this.onGroupChange} filterOption={this.getGroupSelectFilterOptions}
                  value={this.groupIdFromUrl}>
            {
              this.props.selectedChurchGroups.map(group => {
                return (
                  <Select.Option key={`church_group_id_${group.id}`}value={`${group.id}`}>
                    {group.name}
                  </Select.Option>
                );
              })
            }
          </Select>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <WidgetContainer header={this.header}>
        <MembersWidget {...this.widgetParams} position={{ xl: 0, lg: 0, md: 0 }} />
        <PointsEarnedWidget {...this.widgetParams} revivalDates={this.revivalParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <OvercomingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <GuestCardActivitiesWidget {...this.widgetParams} revivalDates={this.revivalParams} position={{ xl: 0, lg: 1, md: 0 }} />
        <GoalsAndAveragesWidget {...this.widgetParams} position={{ xl: 1, lg: 1, md: 0 }} />
        <FastingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <PrayingWidget {...this.widgetParams} revivalDates={this.revivalParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <GroupPerformanceWidget {...this.widgetParams} position={{ xl: 2, lg: 1, md: 0 }} />
      </WidgetContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/allTime/allTime.js